//export const URL = "http://localhost:55000/api"; //local
export const URL = "https://gkdevapi.azurewebsites.net/api"; // azure livnpm
